export default "__VITE_ASSET__ug76QLRC__"